class AuthController {
	constructor($auth) {
		"ngInject";
		this.$auth = $auth;
	}
}

export default AuthController;


// WEBPACK FOOTER //
// ./sources/components/auth/auth.controller.js